import { ArrowUpRightIcon, PhoneIcon } from '@phosphor-icons/react';
import { Tag } from '@/components/kit';
import { formatPhoneHref } from '@/lib/format';
import { mediaUrl } from '@/lib/media';
import type { PublicTenant } from '@/lib/api/schemas';
import { ClientHeader } from '@/features/studio/ClientHeader';

/**
 * The photo leads the page edge to edge: the header sits on it, the studio name and a
 * short line at the bottom, then the accent «Записаться» and a call button.
 */
export function Hero({ studio, onBook }: { studio: PublicTenant; onBook: () => void }) {
  const hero = mediaUrl(studio.heroPath);
  return (
    <section className="ui-hero" aria-label={studio.name}>
      <div className="ui-hero__media" data-hero-media>
        {hero ? (
          <img src={hero} alt={studio.heroAlt || studio.name} fetchPriority="high" decoding="async" crossOrigin="anonymous" />
        ) : null}
      </div>
      <div className="ui-hero__shade" aria-hidden="true" />
      <div className="ui-hero__bar">
        <ClientHeader overlay />
      </div>
      <div className="ui-hero__body">
        {studio.isPreview ? (
          <span className="ui-hero__tag">
            <Tag>Образец</Tag>
          </span>
        ) : null}
        <h1 className="ui-display ui-hero__title">{studio.name}</h1>
        {studio.tagline ? <p className="ui-hero__tagline">{studio.tagline}</p> : null}
        <div className="ui-hero__actions">
          <button type="button" className="ui-hero__cta" onClick={onBook} data-testid="hero-book">
            <span>Записаться</span>
            <ArrowUpRightIcon size={22} weight="bold" aria-hidden />
          </button>
          <a className="ui-hero__call" href={formatPhoneHref(studio.phone)} aria-label="Позвонить в студию">
            <PhoneIcon size={22} aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
}
